import type { z } from 'zod';

/**
 * Парсит произвольный raw-ответ через переданную Zod-схему. Используется
 * в RTK Query transformResponse — гарантирует, что наружу из api-слоя
 * утечёт только то, что описано в контракте.
 *
 * При несоответствии формы — выбрасывает ошибку. Это поведение
 * соответствует правилу api-contracts.md: drift backend↔frontend
 * должен падать громко, а не молча возвращать undefined.
 */
export function parseWithSchema<T>(schema: z.ZodType<T>, raw: unknown): T {
    const parsed = schema.safeParse(raw);
    if (!parsed.success) {
        throw new Error('Некорректный ответ сервера');
    }
    return parsed.data;
}
